import React from 'react';

export interface IconProps {
	color?: string;
	opacity?: string;
}

const RightDropdownArrow = (props: IconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="12"
			height="13"
			viewBox="0 0 12 13"
			fill="none"
			className="arrow-right-icon"
		>
			<path
				d="M4.00781 10.4883L7.99524 6.50085L4.00781 2.51343"
				stroke={props.color}
				strokeOpacity={props.opacity ? props.opacity : '0.3'}
				strokeWidth="1.5"
			/>
		</svg>
	);
};

export default RightDropdownArrow;